import React from 'react';
import styled from 'styled-components';

interface AuthTemplateProps {
    children: React.ReactNode;
}

const AuthTemplateBlock = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background: var(--bg-main);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const WhiteBox = styled.div`
  box-shadow: 0 0 8px var(--shadow-light);
  padding: 2rem;
  width: 360px;
  background: var(--bg-header);
  border-radius: 8px;
`;

const AuthTemplate: React.FC<AuthTemplateProps> = ({ children }) => {
    return (
        <AuthTemplateBlock>
            <WhiteBox>
                {children}
            </WhiteBox>
        </AuthTemplateBlock>
    );
};

export default AuthTemplate;

